import { useEffect, useRef, useState } from 'react';
import { Area, CartesianGrid, ComposedChart, Line, Tooltip, XAxis, YAxis } from 'recharts';
import { monthName } from './workspaceUtils';

export const MonthlyChart = ({ points, metric, color }) => {
  const container = useRef(null);
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const element = container.current;
    const observer = new ResizeObserver(entries => {
      const next = Math.floor(entries[0]?.contentRect.width || 0);
      setWidth(previous => next === previous ? previous : next);
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  return <div ref={container} className="h-56 w-full overflow-hidden" data-testid={`monthly-chart-container-${metric}`}>
    {width > 0 && <ComposedChart width={width} height={224} data={points} margin={{ left: 0, right: 18, top: 12, bottom: 10 }}>
      <CartesianGrid vertical={false} stroke="#e2e8f0" /><XAxis dataKey="month" tickFormatter={monthName} tick={{ fontSize: 10 }} /><YAxis width={45} tick={{ fontSize: 11 }} />
      <Tooltip labelFormatter={monthName} /><Area name="Recorded" dataKey={`${metric}Actual`} stroke={color} fill={color} fillOpacity={0.07} />
      <Line name="Forecast" dataKey={`${metric}Forecast`} stroke={color} strokeDasharray="5 4" strokeWidth={2} connectNulls={false} />
    </ComposedChart>}
  </div>;
};